import { render, staticRenderFns } from "./add-member-dialog.vue?vue&type=template&id=71db37f0&"
import script from "./add-member-dialog.vue?vue&type=script&lang=ts&"
export * from "./add-member-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./add-member-dialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports